export default __webpack_public_path__ + "static/media/icons-enroll-2-32-px.68cff194.svg";